import { render, staticRenderFns } from "./AdvisorCoreNotifications.vue?vue&type=template&id=1c81e374&scoped=true&"
import script from "./AdvisorCoreNotifications.vue?vue&type=script&lang=js&"
export * from "./AdvisorCoreNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AdvisorCoreNotifications.vue?vue&type=style&index=0&id=1c81e374&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c81e374",
  null
  
)

export default component.exports